export default "__VITE_ASSET__C819skxa__"